/**
 * Converts a Spring 6-field cron expression to a French human-readable string.
 * Spring format: "sec min hour dayOfMonth month dayOfWeek"
 * Falls back to the raw expression string if the pattern is not recognized.
 */
export function cronToFrench(cron) {
  if (!cron) return '';
  const parts = cron.trim().split(/\s+/);
  if (parts.length !== 6) return cron;

  const [, min, hour, dom, , dow] = parts;

  // Every N hours: "0 0 */N * * *"
  if (hour.startsWith('*/') && min === '0' && dom === '*' && dow === '*') {
    const n = parseInt(hour.slice(2), 10);
    return n === 1 ? 'Toutes les heures' : `Toutes les ${n} heures`;
  }

  // Every N minutes: "0 */N * * * *"
  if (min.startsWith('*/') && hour === '*' && dom === '*' && dow === '*') {
    const n = parseInt(min.slice(2), 10);
    return n === 1 ? 'Toutes les minutes' : `Toutes les ${n} minutes`;
  }

  // Daily at fixed time: "0 M H * * *"
  if (
    !hour.includes('*') &&
    !hour.includes('/') &&
    !min.includes('*') &&
    !min.includes('/') &&
    dom === '*' &&
    dow === '*'
  ) {
    return `Tous les jours à ${hour.padStart(2, '0')}h${min.padStart(2, '0')}`;
  }

  // Weekdays (Mon–Fri) at fixed time: "0 M H * * 1-5"
  if (!hour.includes('*') && !hour.includes('/') && dow === '1-5' && dom === '*') {
    return `Du lundi au vendredi à ${hour.padStart(2, '0')}h${min.padStart(2, '0')}`;
  }

  return cron;
}
